import React from "react";

const faq6 = () =>{
  return(
    <>
      <p>
        Det är SalamiMetoden som kan rädda din 
        affärsidé. Alltså att minska kostnadsmassan 
        genom att skiva för skiva minska kostnader 
        som inte är absolut tvingande nödvändiga
      </p>
      <p>
        Vilka fasta kostnader kan skjutas upp? 
        Smetas ut över tid (ex v med leasing)?
        Och viktigast – vilka kan elimineras?
      </p>
      <p>
        Smärtsamt? Ja. En fördel dock – varje 
        kapning av ”kostnadskorven” ökar firmans 
        lönsamhet och således din högsta möjliga 
        månadslön.
      </p>
      <p>
        På samma sätt ser du seriöst över hur även 
        rörliga kostnader och de åtgärdskostnader 
        du angett skoningslöst kan krympas.
      </p>
      <p>
        Dock ett tungt undantag: Goda Kostnader! 
        Som bidrar till att öka firmans framgång och
        resultat. ”Skiva” där är det sista du gör.
      </p>
    
    </>
  );
}
export default faq6;